const ProductType = {
  MOL: "plan",
  HOL: "policy"
};

export default ProductType;
